module.exports = __webpack_public_path__ + "static/img/01.46ffc541.png";